import DateHelper from '~/helpers/DateHelper';

export interface NdGroupAttributes {
  id: number,
  hash: string,
  name: string,
  ndGroupFranchiseId?: number,
  createdAt: string,
  updatedAt?: string,
  assignedAt?: string,
}

export interface AssignmentAttributes {
  trackerId: number,
  hash: string,
}

export class NdGroup {
  constructor(private readonly attributes: NdGroupAttributes) {
  }

  get hash(): string {
    return this.attributes.hash;
  }

  get name(): string {
    return this.attributes.name;
  }

  get assignedAt(): string {
    return this.attributes.assignedAt ? DateHelper.format(this.attributes.assignedAt) : '';
  }
}
